// helper functions to encapsulate repeated operations performed
// on module data
// to determine the "provenance" of the module (cf. whether it is original)
// We may wish to discuss incorprating these into the module data model
// or creating a presenter or facade layer for these display patterns

import { ModuleSource } from "~types/types";

export type ModuleWithID = {
    duplicateOf?: string | null;
    id: string;
};

export function getProvenance({ duplicateOf }: ModuleWithID) {
    return duplicateOf ? ModuleSource.Shadow : ModuleSource.Canonical;
}

export function getCanonicalId({ id, duplicateOf }: ModuleWithID) {
    return duplicateOf || id;
}
